const CustomCursor = () => {
  return null;
};

export default CustomCursor;
